import { BaseTextInput } from './BaseTextInput';
import { ControlledTextInput } from './ControlledTextInput';

export const TextInput = {
  Base: BaseTextInput,
  Controlled: ControlledTextInput,
};

export default TextInput;
